import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import analytics from '@adv-mt/mt-segment-wrapper'

function TrackingPageView({
  ad,
  adDetail,
  advertisements,
  bodyType,
  category,
  city,
  filters,
  lastFilter,
  make,
  makeId,
  model,
  modelId,
  pageName,
  pageNumber,
  plateVehicleSelected,
  products,
  province,
  search,
  searchResultsCount,
  searchTerm,
  tab,
  tag,
  title,
  vehicles,
  version,
  withPlateStatus
}) {
  const {domain} = useContext(Context)

  const config = domain.get('config')
  const {
    TRACKING_EVENT_NAMES: {SIGNED_OUT: signedOutEventName}
  } = config.get('tracking')

  const getTrackingData = () =>
    domain.get('get_page_tracking_data_use_case').execute({
      ad,
      adDetail,
      advertisements,
      bodyType,
      category,
      city,
      filters,
      lastFilter,
      make,
      makeId,
      model,
      modelId,
      page: pageName,
      pageNumber,
      plateVehicleSelected,
      province,
      products,
      search,
      searchResultsCount,
      searchTerm,
      tab,
      tag,
      title,
      vehicles,
      version,
      withPlateStatus
    })

  const resetActions = () => {
    analytics.track(signedOutEventName)
    analytics.reset()
  }

  const onTrackingData = ({event, data, identify, reset}) => {
    const isAnalyticsLoaded = window.analytics
    if (!isAnalyticsLoaded) return
    identify && analytics.identify(identify.userId, identify.data)
    reset && resetActions()
    event && analytics.page(event, data)
  }

  useMount(() => {
    getTrackingData().then(onTrackingData)
  })

  return null
}

TrackingPageView.displayName = 'TrackingPageView'

TrackingPageView.propTypes = {
  ad: PropTypes.object,
  adDetail: PropTypes.object,
  advertisements: PropTypes.array,
  bodyType: PropTypes.string,
  category: PropTypes.string,
  city: PropTypes.string,
  filters: PropTypes.object,
  lastFilter: PropTypes.object,
  make: PropTypes.string,
  makeId: PropTypes.string,
  model: PropTypes.string,
  modelId: PropTypes.string,
  pageName: PropTypes.string.isRequired,
  pageNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  plateVehicleSelected: PropTypes.string,
  province: PropTypes.string,
  products: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  search: PropTypes.object,
  searchResultsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  searchTerm: PropTypes.string,
  tab: PropTypes.string,
  tag: PropTypes.string,
  title: PropTypes.string,
  vehicles: PropTypes.array,
  version: PropTypes.string,
  withPlateStatus: PropTypes.string
}

export default TrackingPageView
